import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Permite cargar archivos desde /public/locales/{{lng}}/translation.json
  .use(LanguageDetector) // Detecta el idioma automáticamente (localStorage, navegador, etc.)
  .use(initReactI18next) // Conecta i18n con React
  .init({
    supportedLngs: ['en', 'es'],
    fallbackLng: 'es',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    interpolation: {
      escapeValue: false, // React ya hace escape por seguridad
    },

    react: {
      useSuspense: false, // evita errores con componentes funcionales
    },
  });

export default i18n;